/** French averages prompts (ADR 0051 part 3). */
export const averagesPrompts = {
    mean: (list: string) => `Trouve la moyenne de ${list}.`,
    median: (list: string) => `Trouve la médiane de ${list}.`,
    mode: (list: string) => `Trouve le mode de ${list}.`,
    range: (list: string) => `Trouve l'étendue de ${list}.`,
};
